import { IDmMucHocPhiTinChiActionTypes } from "../../action-types/category/IDmMucHocPhiTinChiActions";
import { IDmMucHocPhiTinChiReducer } from "../../reducer-model/category/IDmMucHocPhiTinChiReducer";
import { IDmMucHocPhiTinChiCopyRequest } from "./../../../model/request/category/dmMucHocPhiTinChiCopyRequest";
import { eReducerStatusBase } from "./../../reducer-model/eReducerStatusBase";
const iniState: IDmMucHocPhiTinChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucHocPhiTinChis: [],
  request: {
    hoc_ky: 0,
    ky_dang_ky: 0,
    nam_hoc: "",
    search_key: undefined,
    hinh_thuc_dao_tao: "chuyen-nganh-chinh",
  },
};
export const mucHocPhiTinChiReducer = (
  state: IDmMucHocPhiTinChiReducer = iniState,
  action: IDmMucHocPhiTinChiActionTypes
): IDmMucHocPhiTinChiReducer => {
  switch (action.type) {
    case "MUC_HOC_PHI_TIN_CHI_LOAD_START":
      return {
        ...state,
        // mucHocPhiTinChiGroupByLopsEditing: [],
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_HOC_PHI_TIN_CHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHocPhiTinChis: action.payload,
      };
    case "MUC_HOC_PHI_TIN_CHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_TIN_CHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_HOC_PHI_TIN_CHI_SAVE_SUCCESS":
      const updatedIds = action.payload.map((x) => x.id);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucHocPhiTinChis: [
          ...state.mucHocPhiTinChis.filter((x) => !updatedIds.includes(x.id)),
          ...action.payload,
        ],
        // mucHocPhiTinChiGroupByLopsEditing: [],
      };
    case "MUC_HOC_PHI_TIN_CHI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_TIN_CHI_UPDATE_STATUS":
      return {
        ...state,
        status: action.payload,
      };
    case "MUC_HOC_PHI_TIN_CHI_CHANGE_REQUEST":
      return {
        ...state,
        request: action.payload,
      };
    case "MUC_HOC_PHI_TIN_CHI_LOCK_START":
      return {
        ...state,
        request: action.payload,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_HOC_PHI_TIN_CHI_LOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTinChis: action.payload,
      };
    case "MUC_HOC_PHI_TIN_CHI_LOCK_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_TIN_CHI_UNLOCK_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTinChis: action.payload,
      };
    case "MUC_HOC_PHI_TIN_CHI_UNLOCK_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_HOC_PHI_TIN_CHI_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowModalCopy: action.payload,
        requestCopy: {} as IDmMucHocPhiTinChiCopyRequest,
      };
    case "MUC_HOC_PHI_TIN_CHI_COPY_CHANGE_REQUEST":
      return {
        ...state,
        requestCopy: {
          ...state.requestCopy,
          ...action.payload,
        },
      };
    case "MUC_HOC_PHI_TIN_CHI_COPY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        mucHocPhiTinChis: [],
      };
    case "MUC_HOC_PHI_TIN_CHI_COPY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        mucHocPhiTinChis: action.payload,
        isShowModalCopy: false,
      };
    default:
      return state;
  }
};
